import { render, staticRenderFns } from "./FileUploadBasicPreview.vue?vue&type=template&id=226f33a0&"
import script from "./FileUploadBasicPreview.vue?vue&type=script&lang=js&"
export * from "./FileUploadBasicPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports